import script from "./NewUserModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewUserModal.vue?vue&type=script&lang=ts&setup=true"

import "./NewUserModal.vue?vue&type=style&index=0&id=5765ffe4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5765ffe4"]])

export default __exports__